import Index from "@/views/Index.vue";
import NotFound from "@/views/NotFound.vue";
import App from "@/App.vue";
import ErrorView from "@/views/ErrorView.vue";

import VueRouter from "vue-router";
import Vue from "vue";

Vue.use(VueRouter);

const AppRouter = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {path: "*", name: "NotFound", component: NotFound, props: false },
    {path: "/:clubId/NotFound", name: "ClubNotFound", component: NotFound, props: true },
    {path: "/Error", name: "Error", component: ErrorView, props: true },
    {path: "/:clubId", name: "Index", component: Index, props: true },
  ],
});

export default AppRouter;
